import { PageTemplate } from "@/components/Templates/PageTemplate";

export default function MonitoringSiteVisits() {
  return (
    <PageTemplate
      title="Sites: Monitoring Site Visits"
      tooltipText="Explore monitoring site visit data across study sites."
      type="site-monitoring-visits"
      selectionIdentifierColumn="site"
      constants={{
        wikiLink: "/wiki/guides/exploration-dashboard-studio-overview",
        idLink: undefined,
      }}
    />
  );
}
